import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-464585d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "mb-2"
}, "User Type:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Option", -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "mb-2"
}, "Search:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary mt-3" }, "Search")
], -1))
const _hoisted_11 = {
  key: 0,
  class: "col-12"
}
const _hoisted_12 = {
  key: 0,
  class: "query-results"
}
const _hoisted_13 = {
  key: 0,
  class: "alert alert-warning fade show mt-3",
  role: "alert"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "We're sorry, but we couldn't find you're looking for. Please review your request and try again. If you need further assistance, feel free to contact us.", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Type:", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Name:", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Last Name:", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Phone Number:", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Email:", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "State:", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "County:", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Address:", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Zip:", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Company Name:", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "License Number:", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Inspection Type:", -1))
const _hoisted_29 = {
  key: 1,
  class: "alert alert-danger fade show mt-3",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createBlock(_component_BModal, {
    buttonLabel: "Search User",
    name: "LookUsers",
    iconClass: "fa fa-search"
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.lookUsers()), ["prevent"])),
        method: "get"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _withDirectives(_createElementVNode("select", {
                name: "",
                id: "",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.roleType) = $event))
              }, [
                _hoisted_5,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.idRoles, (role) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: role.idRole,
                    value: role.idRole
                  }, _toDisplayString(role.name), 9, _hoisted_6))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.roleType]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterQuery) = $event)),
                class: "form-control",
                placeholder: "State, County or Zip"
              }, null, 512), [
                [_vModelText, _ctx.filterQuery]
              ])
            ])
          ]),
          _hoisted_10,
          (_ctx.results !== undefined && _ctx.results !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_ctx.results.success)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (
                _ctx.results.users === undefined ||
                _ctx.results.users === null ||
                _ctx.results.users.length === 0
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results.users, (user) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: user.id_user,
                            class: "col-4 table-results"
                          }, [
                            _createElementVNode("table", null, [
                              _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                  _hoisted_17,
                                  _createElementVNode("td", null, _toDisplayString(_ctx.rolName(user.id_rol)), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _hoisted_18,
                                  _createElementVNode("td", null, _toDisplayString(user.username), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _hoisted_19,
                                  _createElementVNode("td", null, _toDisplayString(user.lastname), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _hoisted_20,
                                  _createElementVNode("td", null, _toDisplayString(user.phone_Number), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _hoisted_21,
                                  _createElementVNode("td", null, _toDisplayString(user.email), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _hoisted_22,
                                  _createElementVNode("td", null, _toDisplayString(user.state), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _hoisted_23,
                                  _createElementVNode("td", null, _toDisplayString(user.country), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _hoisted_24,
                                  _createElementVNode("td", null, _toDisplayString(user.addressess), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _hoisted_25,
                                  _createElementVNode("td", null, _toDisplayString(user.zip_code), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _hoisted_26,
                                  _createElementVNode("td", null, _toDisplayString(user.company_Name), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _hoisted_27,
                                  _createElementVNode("td", null, _toDisplayString(user.license_number), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _hoisted_28,
                                  _createElementVNode("td", null, _toDisplayString(user.inspectionType !== null
                            ? user.inspectionType
                            : ""), 1)
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.results.message), 1)
                    ]))
              ]))
            : _createCommentVNode("", true)
        ])
      ], 32)
    ]),
    _: 1
  }))
}